import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";
import Preloader from "../components/Preloader";
import HeroSection from "../components/Home/HeroSection";
import ServiceSection from "../components/Home/ServiceSection";
import AboutSection from "../components/Home/AboutSection";
import CaseStudiesSection from "../components/Home/CaseStudiesSection";
// import TeamMembersSection from "../components/Home/TeamMembersSection";
import WorkProcessSection from "../components/WorkProcessSection";
import TestimonialSection from "../components/Home/TestimonialSection";
import ContactSection from "../components/Home/ContactSection";
import AaerIntroSection from "../components/Home/AaerIntroSection";
// import BlogSection from "../components/Home/BlogSection";

function Home() {
  const [showCookie, setShowCookie] = useState(
    !localStorage.getItem("paraclearth_cookie_accepted")
  );
  useEffect(() => {
    // Initialize jarallax if it's available
    if (window.jarallax) {
      window.jarallax(document.querySelectorAll(".jarallax"), {
        speed: 0.6,
      });
    }
  }, []);
  //preloader
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Hero Section */}
      <HeroSection />

      {/* Service Section */}
      <ServiceSection />

      {/* About Section */}
      <AboutSection />

      {/* AAER Legal Technology Introduction */}
      <AaerIntroSection />

      {/* Case Studies Section */}
      <CaseStudiesSection />

      {/* Work Process Section */}
      <WorkProcessSection />

      {/* Team Members Section */}
      {/* <TeamMembersSection /> */}

      {/* Popup Video Container */}
      <div id="videoPopup" className="video-popup-iframe">
        <div className="video-content">
          <span className="close-btn" id="videoCloseButton">
            &times;
          </span>
          <div className="ratio ratio-16x9">
            <iframe
              id="videoFrame"
              allowFullScreen
              title="Video Player"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="home-results-section bg-white">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 col-sm-9 col-md-8 col-lg-6 col-xl-6">
              <div className="section-heading">
                <h2>Result-Driven Outcomes for Every Client Project</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div
        className="video-section jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('https://img.youtube.com/vi/ai75OMoUe5U/hqdefault.jpg')" }}
      >
        <div className="milestone-wrapper">
          <div className="container">
            <div
              className="milestone-card wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="600ms"
            >
              {/* Single Milestone */}
              <div className="single-milestone">
                <h2>
                  <span className="counter">35</span>+
                </h2>
                <p className="mb-0">
                  Transactional, Investment &amp; Corporate Advisory matters
                </p>
              </div>

              {/* Single Milestone */}
              <div className="single-milestone">
                <h2>
                  <span className="counter">28</span>+
                </h2>
                <p className="mb-0">Dispute Resolution &amp; Risk Management cases</p>
              </div>

              {/* Single Milestone */}
              <div className="single-milestone">
                <h2>
                  <span className="counter">20</span>+
                </h2>
                <p className="mb-0">
                  Intellectual Property, Technology &amp; Media engagements
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Popup Video */}
        <div className="popup-video">
          <div
            className="video-btn wow fadeInUp"
            data-wow-duration="1000ms"
            data-wow-delay="1000ms"
            data-video="https://www.youtube.com/shorts/ai75OMoUe5U"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clipPath="url(#clip0_1_434)">
                <path
                  d="M5.10545 0.529181C2.94172 -0.711968 1.1875 0.304796 1.1875 2.79837V21.1999C1.1875 23.6959 2.94172 24.7114 5.10545 23.4714L21.1893 14.2474C23.3538 13.0059 23.3538 10.9943 21.1893 9.753L5.10545 0.529181Z"
                  fill="#0E0E0E"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_434">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span className="video-sonar"></span>
          </div>
        </div>
      </div>

      {/* Testimonial Section */}
      <TestimonialSection />

      {/* Contact Section */}
      <ContactSection />

      {/* Blog / Our Publications Section */}
      {/* <BlogSection /> */}
      {/* Cookie Alert */}
      {showCookie && (
        <div className="cookiealert shadow-lg show">
          <h2 className="mb-3">Cookie's Notice</h2>
          <p className="mb-4">
            We use cookies to enhance your experience on our website, support
            social media features, and analyse traffic. By accepting, you agree
            to our use of cookies. Read our{" "}
            <Link to="/contactone" target="_blank">
              Terms of Service.
            </Link>
          </p>
          <button
            className="btn btn-dark btn-sm acceptcookies"
            type="button"
            aria-label="Close"
            onClick={() => {
              localStorage.setItem("paraclearth_cookie_accepted", "true");
              setShowCookie(false);
            }}
          >
            <span>Accept</span>
            <span>Accept</span>
          </button>
        </div>
      )}

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default Home;
